import { render, staticRenderFns } from "./ConfiguratorForm.vue?vue&type=template&id=282292d0&scoped=true&"
import script from "./ConfiguratorForm.vue?vue&type=script&lang=js&"
export * from "./ConfiguratorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282292d0",
  null
  
)

export default component.exports